import { ComponentType } from "react";

import { AbstractRenderer, ILLFAttributeRenderer } from "@multiweb/customization";
import { bridge } from "@multiweb/reactCore/bridge";
import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { createDataSourceAttribute } from "@multiweb/reactUtils";
import { LiteListFrameGeneralAttribute, LiteListFrameGeneralAttributeProps } from "../../../../LiteListFrameGeneralAttribute";

const { stringToBoolean, getExtendedPropertiesFromElement } = bridge;

export abstract class LLFAbstractRenderer extends AbstractRenderer<LiteListFrameGeneralAttributeProps> implements ILLFAttributeRenderer {
    public override get component(): ComponentType<LiteListFrameGeneralAttributeProps> {
        return LiteListFrameGeneralAttribute;
    }

    // @ts-ignore
    // eslint-disable-next-line unused-imports/no-unused-vars
    public getAttributes(element: HTMLElement, ...args: unknown[]): ReadonlyArray<IDataSourceAttribute> {
        const attributeName = element.getAttribute("data-attrname") ?? "";

        return [
            createDataSourceAttribute(attributeName, {
                isIcon: stringToBoolean(element.getAttribute("data-isicon")),
                iconName: element.getAttribute("data-iconname"),
                locKey: element.getAttribute("data-lockey"),
                displayFormat: element.getAttribute("data-displayformat"),
                hidden: !stringToBoolean(element.getAttribute("data-visible"), true),
                backgroundAttrName: element.getAttribute("data-backgroundattr"),
                attributeRendererKey: this.key,
                trimValue: true,
                extendedProperties: getExtendedPropertiesFromElement(element),
            }),
        ];
    }
}
